import _ from 'lodash';
import { timelineEvent } from '@/types';

export default {
  methods: {
    getUserCompanyName(event, participants) {
      const participant = participants.find(p => p.userId === event.userId);
      return _.get(participant, 'organizationName');
    },
    formatCheckinEvents(events, participants) {
      const checkInEvents = _.filter(events, { event: timelineEvent.USER_CHECKIN });
      let htmlContent;
      let formattedTime;
      return checkInEvents.map((eventItem) => {
        formattedTime = this.$options.filters.formatDate(eventItem.timestamp);
        htmlContent = `<span class="font-weight-bold">${eventItem.userDisplayName}</span>
        <span class="font-weight-light">[${this.getUserCompanyName(eventItem, participants)}] <br>
         checked in near ${eventItem.vicinity} at ${formattedTime}</span>`;

        return {
          lat: eventItem.lat,
          lng: eventItem.lng,
          infoText: htmlContent,
          userId: eventItem.userId,
        };
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/checkinEventsUtils.js